module.exports = __webpack_public_path__ + "img/202410_06.4ac70e6e.jpg";